import React from 'react';

import { IRouter } from '@routers/interface';

export const routerExtrutionDetail: IRouter = {
  path: '/processes/processes-detail/:tab/:productionOrderDetailId/extrution-detail/:quantityReportId',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'extrution-detail.name', //translate here for breadcrumb and sidebar
};
